<div class="my-companies-page">
  <app-quota-header [quotaCount]="totalElements" [activeTab]="'companies'"></app-quota-header>
  <div class="top-actions">
    <button mat-raised-button color="primary" class="add-company-btn" (click)="addCompany()">
      <mat-icon>add</mat-icon>
      Добавить компанию
    </button>
  </div>

  <div class="container">
    @if (loading) {
      <div class="loading">
        <div class="spinner"></div>
        <p>Загрузка компаний...</p>
      </div>
    } @else if (error) {
      <div class="error">
        <p>{{ error }}</p>
        <button (click)="load()">Повторить</button>
      </div>
    } @else if (companies.length === 0) {
      <div class="empty-state">
        <mat-icon class="empty-icon">business</mat-icon>
        <p>У вас пока нет зарегистрированных компаний</p>
        <button mat-raised-button color="primary" (click)="addCompany()">
          <mat-icon>add</mat-icon>
          Добавить компанию
        </button>
      </div>
    } @else {
      <div class="companies-grid">
        @for (company of companies; track company.id) {
          <div class="company-card" [class.deleted-card]="company.deleted">
            <div class="card-header">
              <div class="card-header-badges">
                <span class="company-type-badge">{{ applicantTypeLabel(company.applicantTypeEnum) }}</span>
                @if (company.deleted) {
                  <span class="deleted-badge">Удалён</span>
                }
                @if (company.isBanned) {
                  <span class="banned-badge">Заблокирован</span>
                }
              </div>
              @if (company.deleted) {
                <button mat-icon-button color="primary" [disabled]="actionLoading[company.id]"
                        (click)="restoreCompany(company)" matTooltip="Восстановить">
                  <mat-icon>restore</mat-icon>
                </button>
              } @else {
                <button mat-icon-button color="warn" [disabled]="actionLoading[company.id]"
                        (click)="deleteCompany(company)" matTooltip="Удалить">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>

            <h3 class="company-name">{{ company.companyName }}</h3>

            <div class="info-list">
              <div class="info-row">
                <span class="info-label">ИНН</span>
                <span class="info-value">{{ company.inn || '—' }}</span>
              </div>
              @if (company.okpo) {
                <div class="info-row">
                  <span class="info-label">ОКПО</span>
                  <span class="info-value">{{ company.okpo }}</span>
                </div>
              }
              <div class="info-row">
                <span class="info-label">Рег. номер</span>
                <span class="info-value">{{ company.registrationNumber || '—' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Дата регистрации</span>
                <span class="info-value">{{ company.registrationDate || '—' }}</span>
              </div>
              @if (company.legalStatus) {
                <div class="info-row">
                  <span class="info-label">Правовой статус</span>
                  <span class="info-value">{{ company.legalStatus.nameRu }}</span>
                </div>
              }
              <div class="info-row">
                <span class="info-label">Тип поставщика</span>
                <span class="info-value">{{ supplierTypeLabel(company.supplierType) }}</span>
              </div>
              @if (company.actingAs) {
                <div class="info-row">
                  <span class="info-label">Действует как</span>
                  <span class="info-value">{{ actingAsLabel(company.actingAs) }}</span>
                </div>
              }
              @if (company.contractNumber) {
                <div class="info-row">
                  <span class="info-label">Номер договора</span>
                  <span class="info-value">{{ company.contractNumber }}</span>
                </div>
              }
              @if (company.contractDate) {
                <div class="info-row">
                  <span class="info-label">Дата договора</span>
                  <span class="info-value">{{ company.contractDate }}</span>
                </div>
              }
              <div class="info-row created-row">
                <span class="info-label">Дата создания</span>
                <span class="info-value">{{ company.createdTime }}</span>
              </div>
            </div>

          </div>
        }
      </div>

      <mat-paginator
        [length]="pagination.totalElements()"
        [pageSize]="pagination.pageSize()"
        [pageIndex]="pagination.currentPage()"
        [pageSizeOptions]="[6, 15, 30]"
        (page)="onPageChange($event)"
        showFirstLastButtons>
      </mat-paginator>
    }
  </div>
</div>
